<div>
  <!-- <div class="track-vehicle">
    <div class="card-top card-head">
      <h4>Track Vehicle</h4>
      <p>Select all required inputs</p>
    </div>
    <form [formGroup]="trackVehicleForm" (ngSubmit)="trackVehicle(currentPage, recordsPerPage)">
      <div class="form-row">
        <div class="form-item">
          <label>Vehicle Number*</label>
          <input type="text"  formControlName="vehicleNo" required>
          <div class="error" *ngIf="trackVehicleForm.get('vehicleNo')?.invalid && trackVehicleForm.get('vehicleNo')?.touched">
            <small *ngIf="trackVehicleForm.get('vehicleNo')?.errors?.['required']">Vehicle Number is required</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-item">
          <label>Select from Date*</label>
          <input type="date" formControlName="fromDate" required>
          <div class="error" *ngIf="trackVehicleForm.get('fromDate')?.invalid && trackVehicleForm.get('fromDate')?.touched">
            <small *ngIf="trackVehicleForm.get('fromDate')?.errors?.['required']">From Date is required</small>
          </div>
        </div>
        <div class="form-item">
          <label>Select to Date*</label>
          <input type="date" formControlName="toDate" required>
          <div class="error" *ngIf="trackVehicleForm.get('toDate')?.invalid && trackVehicleForm.get('toDate')?.touched">
            <small *ngIf="trackVehicleForm.get('toDate')?.errors?.['required']">To date is required</small>
          </div>
        </div>
      </div>
      <button type="submit"
        class="btn-track btn-action"
        [disabled]="loadingservice.isLoading('track-vehicle')"
       >
        <fa-icon [icon]="['fas', 'magnifying-glass-plus']"></fa-icon>
         TRACK 
        <app-spinner 
        *ngIf="loadingservice.isLoading('track-vehicle')"
        size="normal"
        >        
        </app-spinner>
      </button>
    </form>
  </div> -->

<div class="vehicle-wrapper">
  <div class="top-header">
    <h3>Track Vehicle</h3>
    <p>Select all required inputs</p>
  </div>

  <div class="track-form">
    <form [formGroup]="trackVehicleForm" (ngSubmit)="trackVehicle(currentPage, recordsPerPage)">

      <div class="form-group" #vehicleWrapper>
        <label>Vehicle Number <small>*</small></label>
        <!-- <input type="text"  formControlName="vehicleNo" placeholder="Enter vehicle number" required> -->
          <!-- [(ngModel)]="searchText" -->

        <input type="text"
         formControlName="vehicleNo"
          id="vehicleNo"
          placeholder="Enter vehicle number"
          (input)="onSearch(trackVehicleForm.get('vehicleNo')?.value)"
          class="search-input"
          autocomplete="off"
          >
        <!-- <div *ngIf="suggestions && suggestions.length" class="suggestions-dropdown">
          <div *ngFor="let suggestion of suggestions"
              (click)="selectSuggestion(suggestion)"
              class="suggestion-item">
            <fa-icon [icon]="['fas', 'magnifying-glass']" class="suggestion-icon"></fa-icon>
            <div class="suggestion-text">
              <span class="suggestion-main">{{ suggestion }}</span>
            </div>
          </div>
          <div *ngIf="suggestions.length === 0" class="no-suggestions">No results found</div>
        </div> -->
        <div class="suggestions-dropdown" >
          <ul *ngIf="suggestions && suggestions.length" class="suggestion-list">
            <li *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)">
              <!-- <fa-icon [icon]="['fas', 'magnifying-glass']" class="suggestion-icon"></fa-icon> -->
              <span [innerHTML]="highlightMatch(suggestion)"></span>
            </li>
          </ul>
        </div>

        <div class="error" *ngIf="trackVehicleForm.get('vehicleNo')?.invalid && trackVehicleForm.get('vehicleNo')?.touched">
          <small *ngIf="trackVehicleForm.get('vehicleNo')?.errors?.['required']">Vehicle Number is required</small>
        </div>
      </div>

      <div class="date-form">
        <div class="form-group">
           <label for="fromDate">Select from Date <small>*</small></label>
          <!-- <input type="date" formControlName="fromDate" required> -->
          <!-- <p-datepicker formControlName="fromDate"
              iconDisplay="input"
              [showIcon]="true"
              iconDisplay="input" 
              inputId="buttondisplay" 
              [showButtonBar]="true" 
              [showOnFocus]="false"
              dateFormat="dd/mm/yy"
              /> -->
         
              <p-datepicker formControlName="fromDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="fromDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                            required />

          <div class="error" *ngIf="trackVehicleForm.get('fromDate')?.invalid && trackVehicleForm.get('fromDate')?.touched">
            <small *ngIf="trackVehicleForm.get('fromDate')?.errors?.['required']">From Date is required</small>
          </div>
        </div>
        <div class="form-group">
           <label for="toDate">Select to Date <small>*</small></label>
          <!-- <input type="date" formControlName="toDate" required> -->
            <p-datepicker formControlName="toDate" 
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            inputId="toDate"
                            [showOnFocus]="true" 
                            [showButtonBar]="true" 
                            [maxDate]="today"
                            [readonlyInput]="true"
                            required />
          <div class="error" *ngIf="trackVehicleForm.get('toDate')?.invalid && trackVehicleForm.get('toDate')?.touched">
            <small *ngIf="trackVehicleForm.get('toDate')?.errors?.['required']">To date is required</small>
          </div>
        </div>
      </div>
      <div class="ctr-btn">
        <button type="submit" class="btn-track btn-action">
        <fa-icon [icon]="['fas', 'magnifying-glass-plus']"></fa-icon>
          TRACK 
        </button>
      </div>
    </form>
  </div>
</div>

  <div class="show-table-div" *ngIf="noRecords">
    <div class="error-msg">
        <p>
          <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
          No records found in the given input
        </p>
      </div>
  </div>

  <div class="show-table-div" *ngIf="showTable">
    <div class="top-header">
      <h3>Vehicle Activity</h3>
      <p>Vehicle Details As On {{trackVehicleForm.value.fromDate | date: "dd-MM-yyyy"}} to {{trackVehicleForm.value.toDate | date: "dd-MM-yyyy"}}</p>
    </div>
    <div class="table-container">
      <!-- <div class="card-top card-head">
        <h4>Vehicle Activity</h4>
        <p>Vehicle Details As On {{trackVehicleForm.value.fromDate}} to {{trackVehicleForm.value.toDate}}</p>
      </div> -->
      <div class="tab-head">
        <div class="search-bar">
          <!-- <form [formGroup]="trackVehicleForm" (ngSubmit)="searchVehicles(recordsPerPage)">
            <input type="text" formControlName="searchText" placeholder="Search">
          </form> -->
          <app-generic-search
              [apiUrl]="'track-vehicle/search_suggestion'"
              [resultsApiUrl]="'track-vehicle/'"
              [method]="'POST'"
              [searchParamName]="'search_text'"
              [extraBody]="{ camera_esn: camera_esn, 'vehicle_number': this.rawData.vehicle_number, 'from_date': this.rawData.from_date, 'to_date': this.rawData.to_date }"
              [pageSize]="10"
              [minChars]="2"
              (resultsFetched)="onResults($event)">
          </app-generic-search>
        </div>
        <button (click)="exportToExcel()" class="export-button">
          <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
          EXPORT EXCEL
        </button>
      </div>
      <div class="responsive-table-wrapper">
        <table>
          <thead class="table-name">
            <tr>
              <th>S.No</th>
              <th>Match</th>
              <th>Vehicle Number</th>
              <th>Date</th>
              <th>Time</th>
              <th>Direction</th>
              <th>Camera</th>
              <th>Vehicle Image</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let record of vehicleData; let i = index">
               <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
              <td>
                <span [ngClass]="record.is_match ? 'green-circle' : 'red-circle'"></span>
              </td>
                <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
              <td>{{ record.created_at | date: "dd-MM-yyyy" }}</td>
              <td>{{ record.created_at | date: "hh:mm a" }}</td>
              <td>
               {{ record.direction }}
              </td>
              <td>{{ displayCameraEsn(record) }}</td>
              <td>
                <button (click)="viewImage(record.vehicle_image_url, record.direction)">
                   <fa-icon [icon]="['fas', 'eye']" class="fa-light"></fa-icon>

                </button>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="footer">
          <div class="total-records">Total Records: {{ totalRecords }}</div>
          <div class="pagination-controls">
            <label for="recordsPerPage">Records per page </label>
            <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
            <span>{{ currentPage }} / {{ totalPages }}</span>
            <button (click)="previous()"  [disabled]="!previousPage" class="change-page" title="Previous page">
              <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
            </button>
            <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
              <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add this modal HTML below your table -->
 <app-image-viewer
  [images]="selectedImages"
  [show]="showModal"
  [closeModal]="closeModal"
 ></app-image-viewer>
